import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { CompanyProfileForm } from './use-company-profile.form';

export const useCompanyProfileFormContext = ():
  | UseFormReturn<CompanyProfileForm>
  | never => {
  const form = useFormContext<CompanyProfileForm>();

  if (form === null)
    throw AppError.hookScopeError('useCompanyProfileFormContext error.');

  return form;
};
